module.exports = {
      id: "phone-usage",
      viewBox: "0 0 18 19",
      url: __webpack_public_path__ + "img/icons.56e2db0a.svg#phone-usage",
      toString: function () {
        return this.url;
      }
    }